export const GENDER = [
  {
    key: "female",
    value: "female",
  },
  {
    key: "male",
    value: "male",
  },
  {
    key: "transgender",
    value: "transgender",
  },
];

export const COUNTRY = [
  {
    key: "India",
    value: "india",
    states: [
      {
        key: "Delhi",
        value: "delhi",
        cities: [
          {
            key: "Delhi",
            value: "delhi",
          },
        ],
      },
      {
        key: "Maharashtra",
        value: "maharashtra",
        cities: [
          {
            key: "Pune",
            value: "pune",
          },
          {
            key: "Mumbai",
            value: "mumbai",
          },
        ],
      },
      {
        key: "Bihar",
        value: "bihar",
        cities: [
          {
            key: "Patna",
            value: "patna",
          },
          {
            key: "Gaya",
            value: "gaya",
          },
        ],
      },
    ],
  },
  {
    key: "USA",
    value: "usa",
    states: [
      {
        key: "California",
        value: "california",
        cities: [
          {
            key: "Los Angeles",
            value: "los angeles",
          },
        ],
      },
      {
        key: "Texas",
        value: "texas",
        cities: [
          {
            key: "Houston",
            value: "houston",
          },
          {
            key: "Dallas",
            value: "dallas",
          },
        ],
      },
    ],
  },
];

export const STATE = {
  india: [
    {
      key: "Delhi",
      value: "delhi",
    },
    {
      key: "Maharashtra",
      value: "maharashtra",
    },
    {
      key: "Bihar",
      value: "bihar",
    },
  ],
  usa: [
    {
      key: "California",
      value: "california",
    },
    {
      key: "Texas",
      value: "texas",
    },
  ],
};

export const CITY = {
  delhi: [
    {
      key: "Delhi",
      value: "delhi",
    },
  ],
  maharashtra: [
    {
      key: "Pune",
      value: "pune",
    },
    {
      key: "Mumbai",
      value: "mumbai",
    },
  ],
  bihar: [
    {
      key: "Patna",
      value: "patna",
    },
  ],
  california: [
    {
      key: "Los Angeles",
      value: "los angeles",
    },
  ],
  texas: [
    {
      key: "Houston",
      value: "houston",
    },
  ],
};

export const COMPANY_INDUSTRY_CHOICES = [
  {
    key: "Computer",
    value: "Computer",
  },
  {
    key: "Education",
    value: "Education",
  },
  {
    key: "Entertainment",
    value: "Entertainment",
  },
  {
    key: "Information",
    value: "Information",
  },
  {
    key: "Telecommunication",
    value: "Telecommunication",
  },
  {
    key: "other",
    value: "other",
  },
];

export const FIELD_OF_STUDY = [
  {
    key: "IT",
    value: "IT",
  },

  {
    key: "Management",
    value: "Management",
  },
  {
    key: "Computer Science",
    value: "Computer Science",
  },
];

export const DEGREE_TYPE = [
  {
    key: "Associate Degree",
    value: "associate_degree",
  },

  {
    key: "Bachelors Degree",
    value: "bachelors_degree",
  },
  {
    key: "Doctoral Degree",
    value: "doctoral_degree",
  },
  {
    key: "Joint Degree",
    value: "joint_degrees",
  },
  {
    key: "Masters Degree",
    value: "masters_degree",
  },
  {
    key: "Professional degree",
    value: "professional_degree",
  },
  {
    key: "Professional Diploma",
    value: "professional_diploma",
  },
  {
    key: "Technical Diploma",
    value: "technical_diploma",
  },
  {
    key: "Vocational Degree",
    value: "vocational_degree",
  },
  {
    key: "Senior Secondary",
    value: "senior_secondary",
  },
  {
    key: "Higher Secondary",
    value: "higher_secondary",
  },
];

export const EMPLOYMENT_TYPE = [
  {
    key: "Full Time",
    value: "full_time",
  },
  {
    key: "Part Time",
    value: "part_time",
  },
  {
    key: "Contract",
    value: "contract",
  },

  {
    key: "Contract to Hire",
    value: "contract_to_hire",
  },
];

export const JOB_FUNCTION = [
  {
    key: "Backend Developer",
    value: "Backend Developer",
  },
  {
    key: "Frontend Developer",
    value: "Frontend Developer",
  },
  {
    key: "Java Developer",
    value: "Java Developer",
  },
  {
    key: "React Native Developer",
    value: "React Native Developer",
  },
  {
    key: "UI/UX Designer",
    value: "UI/UX Designer",
  },
  {
    key: "React",
    value: "React",
  },
];

export const formSchema = {
  title: "",
  country: "",
  state: "",
  city: "",
  zipcode: 0,
  is_remote: false,
  role_description: "",
  role_requirements: "",
  role_benefits: "",
  company_industry: "",
  job_function: "",
  skills: [],
  employment_type: "",
  experience: "",
  education: "",
  payment_type: "",
  payment_from: 0,
  payment_to: 0,
  currency: "",
  status: "",
};

export const SEARCHKEYWORDS = [
  "Software",
  "SASS",
  "HTML5",
  "ReactJs",
  "AngularJs",
  "Bootstrap",
  "JQuery",
  "Django",
  "Python",
  "Redux",
  "CSS",
  "PHP",
  "AJAX",
];
export const job_title_limit_length = 64;

export const can_not_be_null = "This field can not be empty";

export const educationFormSchema = {
  school: "",
  college_degree: "",
  field_of_study: "",
  description: "",
  start_date: "",
  end_date: "",
  degree: "",
};

export const professionFormSchema = {
  job_title: "",
  industry: "",
  company: "",
  description: "",
  country: "",
  state: "",
  city: "",
  start_date: null,
  end_date: null,
};

export const TIMEZONE = [
  {
    key: "Asia/Kolkata",
    value: "Kolkata",
  },
  {
    key: "America/New_York",
    value: "New York",
  },
  {
    key: "America/Toronto",
    value: "Toronto",
  },
  {
    key: "UTC",
    value: "UTC",
  },
];

export const CURRENCY = [
  {
    key: "INR(₹)",
    value: "inr",
  },
  {
    key: "USD($)",
    value: "usd",
  },
  {
    key: "EURO(€)",
    value: "euro",
  },
  // {
  //   key: "aud",
  //   value: "aud",
  // },
  // {
  //   key: "jpy",
  //   value: "jpy",
  // },
  // {
  //   key: "gbp",
  //   value: "gbp",
  // },
  // {
  //   key: "chf",
  //   value: "chf",
  // },
  // {
  //   key: "cad",
  //   value: "cad",
  // },
  // {
  //   key: "zar",
  //   value: "zar",
  // },
];
